import { IInstallment } from './Installment';
import { IBudgetPaymentMethod } from './PaymentMethod';

/**
 * As parcelas que o Vectis aceita para esta forma de pagamento.
 *
 * É por aqui que o teto por parcela do contrato recorrente chega à tela: o Vectis marca
 * parcela a parcela em `permiteRealizarPagamentoNessaCondicao`, e uma forma sem nenhuma
 * parcela permitida não fecha o orçamento.
 *
 * Mora fora dos componentes porque o carrinho decide isso em dois lugares — o bloco de
 * parcelamento e a lista de preço por forma — e os dois precisam da mesma resposta. Quando a
 * regra vivia dentro de cada um deles, o bloco de parcelamento escondia o Cartão Recorrente
 * acima do teto e a lista logo abaixo seguia anunciando o preço dele.
 *
 * Parcela sem a marca conta como permitida: nem toda origem de parcela informa o campo.
 */
export default function getAllowedInstallments(
  method: IBudgetPaymentMethod,
): IInstallment[] {
  return method.installments.filter(
    installment => installment.allowed !== false,
  );
}
